<template>
  <div>
    <v-simple-table class="app-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(header, i) in headers"
              :key="`th_lazada-${i}`">
              {{ header.text }}
            </th>
          </tr>
          <tr v-if="stocks.nodes.length === 0">
            <td :colspan="headers.length">
              <div class="d-flex flex-column justify-center py-16 text-center">
                <text-field-label
                  :label="$t('app.table.emptyMessage', [$t('connector.lazada.title')])"
                  class="mb-3 justify-center" />
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item) in stocks.nodes"
            :key="`th_lazada-${item.id}`">
            <td>{{ item.name }}</td>
            <td>
              <div v-if="item.lazadaAccessToken">
                <v-badge
                  color="green accent-4"
                  offset-x="-12"
                  offset-y="11"
                  dot
                  left>
                  <span class="green--text text--accent-4">
                    {{ $t('connector.lazada.table.body.status.available.label') }}
                  </span>
                </v-badge>
                <div class="red--text caption">
                  <span v-if="item.lazadaLoginDayLeft > 0">
                    {{ $t('connector.lazada.table.body.expire.label') }}
                    {{ item.lazadaLoginDayLeft }} วัน
                  </span>
                  <span v-else>
                    {{ $t('connector.lazada.table.body.expired.label') }}
                  </span>
                </div>
              </div>
              <div v-else>
                <v-badge
                  color="grey"
                  offset-x="-12"
                  offset-y="11"
                  dot
                  left>
                  {{ $t('connector.lazada.table.body.status.unavailable.label') }}
                </v-badge>
              </div>
            </td>
            <td>
              <template v-if="item.lazadaAccessToken">
                <lazada-import
                  :item-stock-id="item.id"
                  class="mr-2" />
                <lazada-history
                  :item-stock-id="item.id"
                  :item-stock-name="item.name"
                  class="mr-2" />
                <lazada-logout
                  :item-stock-id="item.id"
                  @submit="refetch()" />
              </template>
              <template v-else>
                <v-btn
                  :href="item.lazadaAuth"
                  color="indigo darken-4"
                  outlined>
                  {{ $t('connector.lazada.btn.connectLazada') }}
                </v-btn>
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-pagination
      v-model="page"
      :length="stocks.pagesCount">
    </v-pagination>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LazadaImport from '@/views/Connector/components/Lazada/LazadaImport.vue'
import LazadaHistory from '@/views/Connector/components/Lazada/LazadaHistory.vue'
import LazadaLogout from '@/views/Connector/components/Lazada/LazadaLogout.vue'
import { GET_STOCKS } from '@/resources/graphql'

export default {
  apollo: {
    stocks: () => ({
      query: GET_STOCKS,
      variables () {
        return {
          page: this.page,
          perPage: this.pageSize
        }
      },
      watchLoading (isLoading) {
        this.setLoading(isLoading)
      }
    })
  },
  components: {
    LazadaLogout,
    LazadaHistory,
    LazadaImport
  },
  data () {
    return {
      isFetching: false,
      page: 1,
      pageSize: 10,
      headers: [
        { text: this.$t('connector.lazada.table.header.store') },
        { text: this.$t('connector.lazada.table.header.status') },
        { text: '' }
      ],
      stocks: {
        nodes: []
      }
    }
  },
  methods: {
    ...mapActions({
      setLoading: 'Notification/setLoading'
    }),
    refetch () {
      this.$apollo.queries.stocks.refetch()
    }
  }
}
</script>

<style>

</style>

<style scoped>

</style>
